import { render, staticRenderFns } from "./HighlightStep2.vue?vue&type=template&id=6d7be720"
import script from "./HighlightStep2.vue?vue&type=script&lang=js"
export * from "./HighlightStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports